var map = {
	"./Capgemini.png": 2665,
	"./address_image.svg": 3906,
	"./animated_logo.svg": 9083,
	"./animated_smit.jpg": 6713,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codechef.png": 4701,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./developerActivity.svg": 9257,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./fullstack.svg": 5137,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./jsFramework.svg": 9655,
	"./manOnTable.svg": 7473,
	"./opshub.png": 5075,
	"./oracle.png": 3492,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./rotary.png": 4869,
	"./spring.png": 1873,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./ui_ux_design.svg": 9163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;